import script from "./VenueInfoWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./VenueInfoWidget.vue?vue&type=script&setup=true&lang=ts"

import "./VenueInfoWidget.vue?vue&type=style&index=0&id=557fd7bc&lang=scss"

const __exports__ = script;

export default __exports__